module.exports = __webpack_public_path__ + "img/None.19631f77.svg";